<template>
    <div class="main-wrapper">
        <div>
            <!-- <layout-header2></layout-header2> -->
            <layout-header></layout-header>
            <breadcrumb67></breadcrumb67>
            <!-- Page Content -->
            <div class="content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <sidebar></sidebar>
                        </div>

                        <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                            <loader></loader>
                        </div>

                        <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                            <div class="card ml-md-4">
                                <div class="card-body">
                                    <h4 class="card-title" style="color:navy"><i class="fa fa-bank"></i> Bank Account
                                        Details</h4>
                                    <div class="col-12 col-md-12">
                                        <div class="d-flex form-group">
                                            <div class="col-9 col-md-9 change-avatar">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Bank Name</label>
                                                <input type="text" placeholder="Bank Name"
                                                    v-model="bank_details.custom_bank_name" class="form-control" />

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Branch</label>
                                                <input type="text" placeholder="Branch Name"
                                                    v-model="bank_details.custom_branch" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>City</label>
                                                <input type="text" placeholder="Branch City"
                                                    v-model="bank_details.custom_city" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Account No.</label>
                                                <input type="text" placeholder="Bank Account No." v-model="bank_details.custom_account_no
                                                    " class="form-control" maxlength="15" minlength="12"
                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Re Enter Account No.</label>
                                                <input type="text" placeholder="Re Enter Account No." v-model="bank_details.custom_re_enter_account
                                                    " class="form-control" maxlength="15" minlength="12"
                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>IFSC Code</label>
                                                <input type="text" placeholder="IFSC Code"
                                                    v-model="bank_details.custom_ifsc_code" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Pan Number</label>
                                                <input type="text" placeholder="Pan No."
                                                    v-model="bank_details.custom_pan_no" class="form-control" maxlength="10" minlength="10" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label style="font-size: 15px;">Attach Cancelled Cheque / Passbook</label>
                                            <div v-if="this.custom_cheque_and_passbook">
                                                <b-button class="btn-info btn-sm" @click="showImageModal1()" v-b-modal.modal-scrollable>View Uploaded</b-button>
                                            </div>
                                            <div v-else>
                                                <input type="file" class="upload" accept="image/*"
                                                    @change="handleFileUpload($event, 'cheque')" style="font-size: 14px;" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label style="font-size: 15px;">Attach Pan</label>
                                            <div v-if="this.custom_attach_pan">
                                                <b-button class="btn-info btn-sm" @click="showImageModal2()" v-b-modal.modal-scroll>View Uploaded</b-button>
                                            </div>
                                            <div v-else>
                                                <input type="file" class="upload" accept="image/*"
                                                @change="handleFileUpload($event, 'pan')" style="font-size: 14px;" />
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <button class="btn btn-primary mt-3" @click="submitForm">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Page Content -->
            <layout-footer></layout-footer>
        </div>
        
      <b-modal id="modal-scrollable" scrollable title="View Document" size="md">
    <div class="d-flex justify-content-center align-items-center">
      <img :src="selectedFile" alt="Attached Degree" class="img-fluid"/>
    </div>
  </b-modal>

  <b-modal id="modal-scroll" scrollable title="View Document" size="md">
    <div class="d-flex justify-content-center align-items-center">
      <img :src="selectedFile2" alt="Attached Degree" class="img-fluid"/>
    </div>
  </b-modal>
    </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
export default {
    data() {
        return {
            bank_details: {
                showspinner: false,
                name: this.$store.state.user.user_id,
                custom_bank_name: "",
                custom_branch: "",
                custom_city: "",
                custom_account_no: "",
                custom_re_enter_account: "",
                custom_ifsc_code: "",
                custom_pan_no: ""
            },
            cheque_file: null,
            cheque_name: "",
            pan_file: null,
            pan_name: "",
            config: config,
            custom_cheque_and_passbook:"",
            custom_attach_pan:"",
            selectedFile: null,
            selectedFile2:null 
        }
    },
    mounted() {
        this.get_doctor_details();
    },
    computed: {

    },
    methods: {

        showImageModal1() {
            console.log("ds",this.custom_cheque_and_passbook)
        this.selectedFile = `https://develop-physio.kneexpert.in${this.custom_cheque_and_passbook}`;
    },  

    showImageModal2() {
        console.log("ss",this.custom_attach_pan)
        this.selectedFile2 = `https://develop-physio.kneexpert.in${this.custom_attach_pan}`;
    },  

        get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name", this.$store.state.user.user_id);
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.bank_details.custom_bank_name = res.data.custom_bank_name;
          this.bank_details.custom_account_no = res.data.custom_account_no;
          this.bank_details.custom_branch = res.data.custom_branch;
          this.bank_details.custom_city = res.data.custom_city;
          this.bank_details.custom_re_enter_account = res.data.custom_re_enter_account;
          this.bank_details.custom_ifsc_code = res.data.custom_ifsc_code;
          this.bank_details.custom_pan_no = res.data.custom_pan_no;
          this.custom_cheque_and_passbook = res.data.custom_cheque_and_passbook;
          this.custom_attach_pan = res.data.custom_attach_pan;
                }
      });
    },

        handleFileUpload(event, type) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64String = reader.result.split(",")[1];
                    if (type === "cheque") {
                        this.cheque_file = base64String;
                        this.cheque_name = file.name;
                    } else if (type === "pan") {
                        this.pan_file = base64String;
                        this.pan_name = file.name;
                    }
                };
                reader.readAsDataURL(file);
            }
        },
        async submitForm() {
    if (!this.disabled) {
        this.$swal({
            text: "Updating Bank Details...",
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                this.$swal.showLoading();
            },
        });

        // Create FormData object
        const formData = new FormData();
        formData.append("name",this.bank_details.name);
        formData.append("custom_bank_name", this.bank_details.custom_bank_name);
        formData.append("custom_branch", this.bank_details.custom_branch);
        formData.append("custom_city", this.bank_details.custom_city);
        formData.append("custom_account_no", this.bank_details.custom_account_no);
        formData.append("custom_re_enter_account", this.bank_details.custom_re_enter_account);
        formData.append("custom_ifsc_code", this.bank_details.custom_ifsc_code);
        formData.append("custom_pan_no", this.bank_details.custom_pan_no);
        formData.append("cheque_name", this.cheque_name);
        formData.append("cheque_file", this.cheque_file);
        formData.append("pan_card_name", this.pan_name);
        formData.append("pan_card_file", this.pan_file);

        try {
            this.showspinner = true;
            // Use CommonApi to send the POST request
            const response = await CommonApi.post_data("sahaj.api.update_doctor_bank_details", formData);

            if (response && response.status_code === 200) {
                this.$swal.fire({
                    icon: "success",
                    title: "Success",
                    text: response.message,
                    showConfirmButton: true,
                });
            } else {
                this.$swal.fire({
                    icon: "error",
                    title: "Error",
                    text: response.message || "Failed to update details.",
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            console.error("Error in API call:", error);
            this.$swal.fire({
                icon: "error",
                title: "Error",
                text: `An error occurred while updating details: ${error.message}`,
                showConfirmButton: true,
            });
        } finally {
        this.showspinner = false;  // Hide loader after API call is complete
      }
    }
}


    },
};
</script>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/AccountDetails.vue